import { render, staticRenderFns } from "./ApprovalMailLine.vue?vue&type=template&id=c1925a4c&scoped=true"
import script from "./ApprovalMailLine.vue?vue&type=script&lang=js"
export * from "./ApprovalMailLine.vue?vue&type=script&lang=js"
import style0 from "./ApprovalMailLine.vue?vue&type=style&index=0&id=c1925a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1925a4c",
  null
  
)

export default component.exports